import React from "react";
import { Typography } from "antd";
import ScribbleForm from "../containers/ScribbleForm";

export default () => (
  <>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "2rem"
      }}
    >
      <Typography.Title level={3}>Neue Eintagsfliege</Typography.Title>
    </div>
    <ScribbleForm />
  </>
);
